import { render } from "./ImageSegment.vue?vue&type=template&id=3108bc21"
import script from "./ImageSegment.vue?vue&type=script&lang=js"
export * from "./ImageSegment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__